import React, { useState, forwardRef } from 'react';
import DropdownLeftIcon from '@assets/icons/drop-rigth-icon.svg';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2'
import InfoTaskVariablesModal from '../InfoTaskVariablesModal';

const TaskVariables = ({ hasRouteVariables, taskType, isNotAClient }, ref) => {
	const lan = useLanguage();
	const [showPopup, setShowPopup] = useState(false);
	const handlePopup = () => {
		setShowPopup(!showPopup);
	};
	return (
		<>
			{showPopup && (
				<InfoTaskVariablesModal
					lan={lan}
					closeModal={handlePopup}
					showModal={showPopup}
					taskTypeId={taskType.id}
					taskType={taskType}
				/>
			)}
			{isNotAClient && hasRouteVariables ? (
				<Grid container className='mx-3'>
					<Grid size={12} container className='mt-3'>
						<button className='btn full-width text-left buttonFunction' onClick={handlePopup}>
							<Grid container className='my-2'>
								<Grid size={10}>
									<span className='text-left'> {lan.routeTaskVariables.toUpperCase()}</span>
								</Grid>
								<Grid size={2} className='d-flex mr-3 align-content-end'>
									<img className='CreateTask-padding-button ml-auto' src={DropdownLeftIcon} alt='' />
								</Grid>
							</Grid>
						</button>
					</Grid>
				</Grid>
			) : null}
		</>
	);
};

export default forwardRef(TaskVariables);
